import { useState } from "react";
import { message } from "antd";
import {
  loginUser,
  verifyCode,
  forgotPassword,
  setIsLogged,
  setToken,
  setLoggedAt,
  setData,
  setProvider,
} from "../Actions";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
export const useSignIn = () => {
  const { t } = useTranslation();
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [verificationCode, setVerificationCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("login"); // login | verify
  const [tempToken, setTempToken] = useState(null);
  const profile = useSelector((state) => state.profile);
  const dispatch = useDispatch();

  const handleInputChange = (field) => (e) => {
    setCredentials((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleLoginAttempt = async (isResend = false) => {
    setLoading(true);
    try {
      const result = await loginUser(credentials.email, credentials.password);

      if (result?.token) {
        // store token only in memory, not localStorage
        setTempToken(result.url);
        setStep("verify");
        message.info(
          isResend ? t("verification_code_resent") : t("verification_code_sent")
        );
      }
      console.log("Login resultttt:", result.message);
      if (result?.Error === "ACCOUNT_NEW") {
        message.warning(t("account_being_activated"));
      }
       if (result?.message === "INVALID_CREDENTIALS") {
        message.warning(t("invalid_credentials"));
      }
      if (result?.message === "ACCOUNT_NEW") {
        message.warning(t("account_being_activated"));
      }
    } catch (err) {
      const errorCode = err?.response?.data?.request?.code;
      const errorKey = err?.response?.data?.result?.Error;

      if (errorCode === 1079 || errorKey === "ACCOUNT_NEW") {
        message.warning(t("account_being_activated"));
      } else {
        message.error(t("invalid_credentials"));
      }
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyCode = async () => {
    setLoading(true);
    try {
      // send verificationCode + tempToken to backend
      const data = await verifyCode(verificationCode, tempToken);

      if (data?.request?.status && data?.result?.access_token) {
        // ✅ only store the final verified token

        dispatch(setIsLogged(true));
        dispatch(setToken(data.result.access_token));
        dispatch(setData(data.result.profile));
        dispatch(setProvider(data.result.provider));
        dispatch(setLoggedAt()); //new Date(Date.now()).toJSON()
        message.success(t("login_successful"));
        // window.location.reload();
        localStorage.setItem(
          "charge_service_type",
          data.result.provider.charge_service_type
        );
        localStorage.setItem(
          "charge_service",
          data.result.provider.charge_service
        );
        window.location = "dashboard";
      }
    } catch {
      message.error(t("invalid_code"));
    } finally {
      setLoading(false);
    }
  };
  const handleForgotPassword = async () => {
    setLoading(true);
    try {
      // send verificationCode + tempToken to backend
      const data = await forgotPassword(credentials.email);
      message.success(t(data.result.message));
      setStep("login");
    } catch {
      message.error(t("invalid_email"));
    } finally {
      setLoading(false);
    }
  };


  return {
    step,
    loading,
    credentials,
    verificationCode,
    setStep,
    handleInputChange,
    setVerificationCode,
    handleLoginAttempt,
    handleVerifyCode,
    handleForgotPassword,
  };
};
